import collectionClient from '@/api/teamCollections.js'

// initial state
const state = {
  showCollectionsModal: false,
  collections: [],
  itemAddingToCollection: null
}

// getters
const getters = {
  collections (state) {
    return state.collections
  },

  showCollectionsModal: (state) => {
    return state.showCollectionsModal
  },

  itemAddingToCollection: (state) => {
    return state.itemAddingToCollection
  }
}

// actions
const actions = {
  fetchCollections: (context) => {
    return collectionClient.listAll()
      .then((data) => {
        context.commit(SET_COLLECTIONS, data)
      })
  },

  performCreate: (context, payload) => {
    collectionClient.create(payload)
      .then(() => {
        context.dispatch('fetchCollections')
      })
  },

  performDelete: (context, collectionId) => {
    collectionClient.delete(collectionId)
      .then(() => {
        context.dispatch('fetchCollections')
      })
  },

  showCollectionsModal: (context) => {
    context.commit(SET_SHOW_COLLECTIONS_MODAL, true)
  },

  hideCollectionsModal: (context) => {
    context.commit(SET_SHOW_COLLECTIONS_MODAL, false)
  },

  setTrackAddingToCollection: (context, item) => {
    context.commit(SET_ITEM_ADDING_TO_COLLECTION, item)
  },

  clearCollections: (context) => {
    context.commit(SET_COLLECTIONS, [])
  }
}

// mutations
const SET_COLLECTIONS = 'SET_COLLECTIONS'
const SET_SHOW_COLLECTIONS_MODAL = 'SET_SHOW_COLLECTIONS_MODAL'
const SET_ITEM_ADDING_TO_COLLECTION = 'SET_ITEM_ADDING_TO_COLLECTION'

const mutations = {
  [SET_COLLECTIONS]: (state, payload) => {
    state.collections = payload
  },

  [SET_SHOW_COLLECTIONS_MODAL]: (state, value) => {
    state.showCollectionsModal = value
  },

  [SET_ITEM_ADDING_TO_COLLECTION]: (state, item) => {
    state.itemAddingToCollection = item
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
